import image from "../assets/k.jpg";

const TeamList = [
  {
    id: 1,
    commodity_main_image: `${image}`,
    name: "Johanness Doe",
    speciality: "Manager",
  },
  {
    id: 2,
    commodity_main_image: `${image}`,
    name: "Johanness Doe",
    speciality: "Manager",
  },
  {
    id: 3,
    commodity_main_image: `${image}`,
    name: "Johanness Doe",
    speciality: "Manager",
  },
  {
    id: 4,
    commodity_main_image: `${image}`,
    name: "Johanness Doe",
    speciality: "Manager",
  },
  {
    id: 5,
    commodity_main_image: `${image}`,
    name: "Johanness Doe",
    speciality: "Manager",
  },
  {
    id: 6,
    commodity_main_image: `${image}`,
    name: "Johanness Doe",
    speciality: "Manager",
  },
  {
    id: 7,
    commodity_main_image: `${image}`,
    name: "Johanness Doe",
    speciality: "Manager",
  },
  {
    id: 8,
    commodity_main_image: `${image}`,
    name: "Johanness Doe",
    speciality: "Manager",
  },
];
export default TeamList;
